'use client';

import type { ReactNode } from 'react';
import useStyles from './styles';

const CategoryPageLayout = ({ children }: { children: ReactNode }) => {
  const classes = useStyles();
  return <main className={classes.main}>{children}</main>;
};

export default CategoryPageLayout;
